import styled from 'styled-components';

type SizeProps = {
  $width?: number | string;
  $height?: number | string;
};

const toCSS = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

export const Container = styled.div<SizeProps>`
  display: flex;
  flex-direction: column;
  max-width: 450px;
  width: 100%;
  ${({ $width }) => $width !== undefined && `width: ${toCSS($width)};`}
  ${({ $height }) => $height !== undefined && `height: ${toCSS($height)};`}
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const CalculatorBox = styled.div`
  background: #ffffff;
  border: 1px solid #ebebeb;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const FlagCurrencyGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #ebebeb;
  margin: 4px 0;
`;

export const InfoBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 0;
`;

export const DropdownRow = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const YouPayRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px 0;
`;
